import React from 'react'

function TextTitle(props) {
  return (
    <div>
        <p>{props.label}</p>
    </div>
  )
}

export default TextTitle